// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-header{display:block;background:url(https://paramount.de/franchise/img/paramount-brands-background.jpg) no-repeat 0;background-size:cover;min-height:420px}.card{transition:box-shadow .2s}.card:hover{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
